<template>
  <div class="series-progress-line">
    <div class="line" :style="progressLineStyles"></div>
    <div class="content">
      <div class="item" v-for="(item, index) in progressItems" :key="index">
        <div class="label">{{ item.label }}</div>
        <div class="value">{{ item.value }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { generateGradientStyles } from '@/app/app.service';

export default defineComponent({
  name: 'SeriesProgressLine',

  /**
   * 属性
   */
  props: {
    series: Object,
  },

  /**
   * 数据
   */
  data() {
    return {};
  },

  /**
   * 计算属性
   */
  computed: {
    progressLineStyles() {
      const gradientStyles = generateGradientStyles(this.series.gradient);

      return {
        width: this.series.progress ? `${this.series.progress.percent}%` : '0%',
        background: gradientStyles,
      };
    },

    progressItems() {
      let items = [];

      const completedPercent = this.series.progress
        ? this.series.progress.percent
        : 0;

      const completed = this.series.progress
        ? this.series.progress.completed
        : 0;

      const remainingPrecent = `${(100 - parseFloat(completedPercent)).toFixed(
        2,
      )}`;

      const remaining =
        parseInt(this.series.nodeCount, 10) - parseInt(completed, 10);

      const completedItem = {
        label: '完成：',
        value: `${completedPercent}% / ${completed}节`,
      };

      const remainingItem = {
        label: '剩余：',
        value: `${remainingPrecent}% / ${remaining}节`,
      };

      if (completedPercent) {
        items.push(completedItem);
      }

      if (remainingPrecent && remainingPrecent !== 100) {
        items.push(remainingItem);
      }

      return items;
    },
  },

  /**
   * 已创建
   */
  created() {
    //
  },

  /**
   * 组件方法
   */
  methods: {},

  /**
   * 使用组件
   */
  components: {},
});
</script>

<style scoped>
@import './styles/series-progress-line.css';
</style>
